<template>
  <router-view/>
  <CookieBanner @open-privacy="showPrivacyModal = true" @open-cookies="showCookiesModal = true" />
  
  <PrivacyModal 
    :visible="showPrivacyModal" 
    title="Privatumo politika"
    @close="showPrivacyModal = false"
  >
    <PrivacyContent />
  </PrivacyModal>
  
  <PrivacyModal 
    :visible="showCookiesModal" 
    title="Slapukų politika"
    @close="showCookiesModal = false"
  >
    <CookiesContent />
  </PrivacyModal>
</template>

<script>
import CookieBanner from '@/components/CookieBanner.vue'
import PrivacyModal from '@/components/PrivacyModal.vue'
import PrivacyContent from '@/views/Privacy.vue'
import CookiesContent from '@/views/Cookies.vue'

export default {
  name: 'App',
  components: {
    CookieBanner,
    PrivacyModal,
    PrivacyContent,
    CookiesContent
  },
  data() {
    return {
      showPrivacyModal: false,
      showCookiesModal: false
    }
  },
  mounted() {
    // Listen for modal open events
    window.addEventListener('arunvilkasa:open-privacy', () => {
      this.showPrivacyModal = true
    })
    window.addEventListener('arunvilkasa:open-cookies', () => {
      this.showCookiesModal = true
    })
  },
  beforeUnmount() {
    window.removeEventListener('arunvilkasa:open-privacy', () => {})
    window.removeEventListener('arunvilkasa:open-cookies', () => {})
  }
}
</script>